module.exports = __webpack_public_path__ + "static/PANO_20140111_174941-73c0bd9a83a33981b4c0d86369d3dbd3.jpg";